export default __webpack_public_path__ + "static/tigress-6b7701a56801dd12cc7c041923d96f85.jpg";